import React from "react";

import {
  IoLocationOutline,
  IoClipboardOutline,
  IoTimeOutline,
} from "react-icons/io5";

/**
 * IconText component renders a text with an optional icon.
 *
 * @param {Object} props Component props.
 * @param {string} props.icon Icon key (`location`, `clipboard`, or `time`).
 * @param {string} props.text The text to display alongside the icon.
 * @param {boolean} [props.truncate=false] Whether to truncate overflowing text.
 * @param {string} [props.classes] Additional CSS classes for styling the component.
 * @returns {JSX.Element} Icon-and-text row.
 * @example
 * return (
 *  <IconText icon='location' text='You are here' classes='text-gray-500' />
 * )
 */
const IconText = ({
  icon,
  text,
  truncate = false,
  classes,
}) => {
  let IconComponent;
  switch (icon) {
    case "location":
      IconComponent = <IoLocationOutline size={12} />;
      break;
    case "clipboard":
      IconComponent = <IoClipboardOutline size={12} />;
      break;
    case "time":
      IconComponent = <IoTimeOutline size={12} />;
      break;
    default:
      IconComponent = null;
  }
  return (
    <div
      className={`flex flex-row items-center ${classes} pr-2`}
    >
      <div className="max-sm:hidden rounded-3xl p-1 shadow-sm">{IconComponent}</div>
      <div className={`text-sm pr-2 rounded-md ${truncate ? "truncate" : ""}`}>
        <p className={`${truncate ? "truncate" : ""}  max-sm:ml-1 `}>{text}</p>
      </div>
    </div>
  );
};

export default IconText;
